enum NotificationEventType {
  AUTO_TODO_CREATE_LAR_AID = 'notification.create-lar-aid',
  AUTO_TODO_CREATE_DAR_AID = 'notification.create-dar-aid',
  AUTO_TODO_USER_ONBOARDING_COMPLETE = 'notification.auto-todo-user-onboarding-complete',
  AUTO_TODO_CREATE_OOR_TITLE_AID = 'notification.create-oor-aid',
  AUTO_TODO_CREATE_ECR_TITLE_AID = 'notification.create-ecr-aid'
}

export default NotificationEventType
